import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCommunitySettings } from '@guuru/community-web';
import { LANGUAGE_CODES, type LanguageCode } from '@guuru/languages-common';
import { loadTranslations } from '@guuru/translation-web';
import { parse } from '@guuru/url-common';

const supportedLanguageCodes: ReadonlySet<string> = new Set(LANGUAGE_CODES);

const isSupportedLocale = (locale: string): locale is LanguageCode =>
  supportedLanguageCodes.has(locale);

const getSupportedLocale = (locale: string) =>
  isSupportedLocale(locale) ? locale : undefined;

const useSetLanguage = function () {
  const { i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const extractedBrowserLocale = navigator.language.split('-')[0];
  const { defaultLanguage, partnerId } = useCommunitySettings();

  useEffect(() => {
    const { locale: localeParam } = parse(window.location.search);
    const locale = getSupportedLocale(String(localeParam));
    const browserLocale = getSupportedLocale(extractedBrowserLocale);
    const languageCode: LanguageCode =
      locale || localStorage.locale || browserLocale || defaultLanguage || 'en';
    localStorage.locale = languageCode;

    const initTranslations = async () => {
      await i18n.changeLanguage(languageCode);
      await loadTranslations(languageCode, ['pages'], partnerId);
      setLoading(false);
    };

    initTranslations();
  }, [defaultLanguage, i18n, partnerId, extractedBrowserLocale]);
  return { loading };
};

export default useSetLanguage;
